export const API_KEY = "AIzaSyDUom3AnIIKszl05I5CQPz0kEzlIGlIMz8";
export default API_KEY;
